import { Link } from "react-router-dom";

import {
  DESIGN_PARTNER_PATHS,
  DESIGN_PARTNER_PRIVACY_EMAIL,
} from "../routes";

export function ContactPage() {
  return (
    <section className="page" id="contact" data-testid="dp-page-contact">
      <div className="wrap policy">
        <div className="eyebrow">Contact</div>
        <h1>Talk to Zephix.</h1>
        <p className="lead">
          Interested in the design-partner program, partnership discussions, or privacy questions?
          Request a conversation and tell us the reason for reaching out.
        </p>
        <Link className="btn primary" to={DESIGN_PARTNER_PATHS.apply}>
          Request a conversation →
        </Link>
        <h2>For privacy requests</h2>
        <p>
          Use the design-partner form and select “Other” as your primary challenge, then state
          “Privacy request” in the notes. You can also email{" "}
          <a href={`mailto:${DESIGN_PARTNER_PRIVACY_EMAIL}`}>
            <b>{DESIGN_PARTNER_PRIVACY_EMAIL}</b>
          </a>
          — this mailbox is monitored.
        </p>
      </div>
    </section>
  );
}
